// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FILTER_MODAL_CLOSE = "Zavrie\u0165";
export const BZ2_NO_SUCH_OPTION = "\u017diadna tak\u00e1 mo\u017enos\u0165 tu nie je";
export const CONFIRM = "Potvr\u010f";
